
import lang from "@/views/modules/ApplicationBudgets/language/en";


import Editor from '@tinymce/tinymce-vue';

export default {
    name: "edit-applicationbudgets",
 
    components: {
       
        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            products: [],
            product: {
                category: null,
                name: null,
                price: null,
                status: true,
                description: null,
            },
            lang:[],
        }
    },
    mounted() {
      //  this.getProducts();
      //  this.checkPermisson();
        this.lang = lang;
    },
    methods: {
        // saveProduct() {
        //     const self = this;
        //     self.loading = true;
        //     axios.post('api/modules/products', self.product).then(function (response) {
        //         self.loading = false;
        //         self.$notify({
        //             title: self.$i18n.t('Success').toString(),
        //             text: self.$i18n.t('Data saved correctly').toString(),
        //             type: 'success'
        //         });
        //         self.$router.push('/modules/products/' + response.data.product.id + '/edit');
        //     }).catch(function () {
        //         self.loading = false;
        //     });
        // },
        // getProducts() {
        //     const self = this;
        //     self.loading = false;
        // },
        // checkPermisson() {
        //     const self = this;
        //     self.loading = false;
        // },
    }
}